module.exports = __webpack_public_path__ + "static/media/hero-image.82d8d3c4.png";